// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1P7ma","col":"styles_col__34g7e"};